/* ============================================================================
 * PRODUCT GALLERY (js__product-gallery.js)
 * - Loaded on ALL product templates.
 * ============================================================================ */

const initGallery = () => {
  const gallery = document.querySelector('.gallery');
  if (gallery) {
    const lightbox = GLightbox({
      openEffect: 'fade'
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initGallery();
});